export const onBoardingMenu = [
  {
    title: "Pending",
    value: "Pending",
    display: true,
  },
  {
    title: "Rejected",
    value: "Rejected",
    display: true,
  },
  {
    title: "Approved",
    value: "Approved",
    display: true,
  },
];

export const onBoardingDetailMenu = [
  {
    title: "Personal Information",
    value: "personal_information",
    display: true,
  },
  {
    title: "Company Information",
    value: "company_information",
    display: true,
  },
  {
    title: "Vehicle Details & Other",
    value: "vehicle_details_other",
    display: true,
  },
];

export const onBoardingDetailVehicleOtherMenu = [
  {
    title: "Vehicle Details",
    value: "vehicle_details",
    display: true,
  },
  {
    title: "Other",
    value: "other",
    display: true,
  },
  {
    title: "Deleted",
    value: "deleted",
    display: true,
  },

];
export const dumyData = {
  id: "05c50337-e4d5-4a1d-aef6-bc573c6e4ea0",
  numberPlate: "G-026-XV",
  userId: "dcf01cbe-01dd-4991-9408-4e42b17f3b0c",
  verify: "Approved",
  carId: "49e48ad5-d2ac-40fe-b3aa-5f5701eccaf5",
  brandId: "ca58bd7c-d3f8-48d3-b6cc-e6fb77c51db6",
  isCurrent: true,
  networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
  createdAt: "2022-04-21T17:58:56.000Z",
  updatedAt: "2022-04-21T17:59:14.000Z",
  car: {
    id: "49e48ad5-d2ac-40fe-b3aa-5f5701eccaf5",
    carName: "E 220",
    category: "CARRIER",
    seatingCapacity: 4,
    year: 2011,
    brandId: "ca58bd7c-d3f8-48d3-b6cc-e6fb77c51db6",
    color: null,
    createdAt: "2021-09-14T14:14:37.000Z",
    updatedAt: "2023-10-31T09:14:20.000Z",
  },
  brand: {
    id: "ca58bd7c-d3f8-48d3-b6cc-e6fb77c51db6",
    brandName: "Mercedes-Benz",
    createdAt: "2021-09-14T11:03:18.000Z",
    updatedAt: "2021-09-14T11:03:18.000Z",
  },
  onboardingDocs: [
    {
      id: "034d343c-be20-11ef-8d4a-0aeab10ce125",
      onBoardingId: "05c50337-e4d5-4a1d-aef6-bc573c6e4ea0",
      networkDocId: "a1b9c7e8-7b0f-4640-a689-8928c1a72a1f",
      data: '{"value": "ismail Lazam"}',
      createdAt: "2024-12-19T15:43:37.000Z",
      updatedAt: "2024-12-19T15:43:37.000Z",
    },
    {
      id: "ba0f16d8-9869-11ef-8d4a-0aeab10ce125",
      onBoardingId: "05c50337-e4d5-4a1d-aef6-bc573c6e4ea0",
      networkDocId: "f9dde8d8-5343-4805-8d1b-a56ad6ab2196",
      data: '{"front":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563886102","back":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563901237","expiry":"2024-01-01 00:00:00"}',
      createdAt: "2024-11-01T15:55:33.000Z",
      updatedAt: "2024-11-01T15:55:33.000Z",
    },
    {
      id: "ba0dcb24-9869-11ef-8d4a-0aeab10ce125",
      onBoardingId: "05c50337-e4d5-4a1d-aef6-bc573c6e4ea0",
      networkDocId: "9f5b8f46-cf65-46d8-aaa6-96cb7849a7dd",
      data: '{"front":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563723655","back":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563603821","expiry":"2024-01-01 00:00:00"}',
      createdAt: "2024-11-01T15:55:33.000Z",
      updatedAt: "2024-11-01T15:55:33.000Z",
    },
    {
      id: "ba0c647c-9869-11ef-8d4a-0aeab10ce125",
      onBoardingId: "05c50337-e4d5-4a1d-aef6-bc573c6e4ea0",
      networkDocId: "35428c2d-84f0-4003-bcbb-625e40725588",
      data: '{"front":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563225565","back":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563281605","side":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563326246"}',
      createdAt: "2024-11-01T15:55:33.000Z",
      updatedAt: "2024-11-01T15:55:33.000Z",
    },
    {
      id: "ba0b3797-9869-11ef-8d4a-0aeab10ce125",
      onBoardingId: "05c50337-e4d5-4a1d-aef6-bc573c6e4ea0",
      networkDocId: "2d53eaae-4c4c-4b02-a725-d36b4f2e3748",
      data: '{"image":"https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563624693","expiry":"2024-03-01 00:00:00"}',
      createdAt: "2024-11-01T15:55:33.000Z",
      updatedAt: "2024-11-01T15:55:33.000Z",
    },
    {
      id: "b8592c34-be1f-11ef-8d4a-0aeab10ce125",
      onBoardingId: "05c50337-e4d5-4a1d-aef6-bc573c6e4ea0",
      networkDocId: "00ac40d0-68a8-4b76-b4a5-d856130a1c7c",
      data: '{"value": "NL41 ABNA 0513 2045 12"}',
      createdAt: "2024-12-19T15:41:31.000Z",
      updatedAt: "2024-12-19T15:41:31.000Z",
    },
  ],
  user: {
    id: "dcf01cbe-01dd-4991-9408-4e42b17f3b0c",
    displayName: "Lazam",
    fullName: "Ismail Lazam",
    email: "lazam@live.nl",
    address: "Alexander Flemingstraat 23",
    addressLineTwo: "",
    postalCode: "2035EB ",
    city: "Haarlem ",
    phoneNumber: "+31638692120",
    role: "Driver",
    country: null,
    activeCountry: "Netherlands",
    activeCity: "amsterdam",
    deviceName: null,
    verified: true,
    block: false,
    star: true,
    termsandconditions: false,
    ghost: false,
    lastLogin: "1716026724563",
    lat: "52.3726806640625",
    lng: "4.71061122514068",
    location: null,
    status: "occupied",
    IBAN: "NL41 ABNA 0513 2045 12",
    onBoardingVerified: "Approved",
    userId: null,
    passwordResetToken: "251428",
    passwordTokenExpire: "2022-12-09T12:30:17.000Z",
    online: false,
    locationTimeStamp: "2024-05-18T11:55:53.000Z",
    pushToken: null,
    imageUrl:
      "https://mobio-og-new.s3.eu-central-1.amazonaws.com/1650563697682",
    operatingSystem: "ios",
    isDeleted: false,
    deleteReason: null,
    companyName: "Taxi Good Services ",
    companyAddress: "Alexander Flemingstraat 23",
    companyPostCode: "2035EB",
    companyCity: "Haarlem",
    companyRegistrationNumber: "73343862",
    companyVATNumber: "066610618B-02",
    bankAccountNumber: null,
    bankAccountHolderName: "ismail Lazam",
    vatPercentage: null,
    orgId: null,
    appVersion: "",
    adminId: null,
    networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
    isVatReversed: false,
    createdAt: "2022-04-21T15:00:22.000Z",
    updatedAt: "2024-10-28T15:55:04.000Z",
  },
  network: {
    id: "297be3e5-53c6-480f-9b54-e1aa47efe162",
    name: "Amsterdam",
    country: "Netherlands",
    city: "Amsterdam",
    supportNumber: "31203030771",
    countryCode: "+31",
    currency: null,
    createdAt: "2023-11-06T12:26:45.000Z",
    updatedAt: "2024-12-19T15:38:06.000Z",
    networkDocs: [
      {
        id: "f9dde8d8-5343-4805-8d1b-a56ad6ab2196",
        name: "Rijbewijs",
        mandatory: true,
        imageType: "FrontBack",
        pattern: null,
        expiryIncluded: true,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Image",
        createdAt: "2024-11-01T15:49:30.000Z",
        updatedAt: "2024-11-01T15:49:30.000Z",
      },
      {
        id: "a1b9c7e8-7b0f-4640-a689-8928c1a72a1f",
        name: "Account Holder Name",
        mandatory: true,
        imageType: "Single",
        pattern: null,
        expiryIncluded: false,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Text",
        createdAt: "2024-12-19T15:38:06.000Z",
        updatedAt: "2024-12-19T15:38:06.000Z",
      },
      {
        id: "9f5b8f46-cf65-46d8-aaa6-96cb7849a7dd",
        name: "Kenteken Kaart",
        mandatory: true,
        imageType: "FrontBack",
        pattern: null,
        expiryIncluded: true,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Image",
        createdAt: "2024-11-01T15:49:30.000Z",
        updatedAt: "2024-11-01T15:49:30.000Z",
      },
      {
        id: "6d480080-aa4c-4eb5-b928-c432f5452b9a",
        name: "Account Type",
        mandatory: true,
        imageType: "Single",
        pattern: null,
        expiryIncluded: false,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Text",
        createdAt: "2024-12-19T15:38:06.000Z",
        updatedAt: "2024-12-19T15:38:06.000Z",
      },
      {
        id: "35428c2d-84f0-4003-bcbb-625e40725588",
        name: "Voertuig Foto's",
        mandatory: true,
        imageType: "FrontBackSide",
        pattern: null,
        expiryIncluded: false,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Image",
        createdAt: "2024-11-01T15:49:30.000Z",
        updatedAt: "2024-11-01T15:49:30.000Z",
      },
      {
        id: "2d53eaae-4c4c-4b02-a725-d36b4f2e3748",
        name: "Verzekering",
        mandatory: true,
        imageType: "Single",
        pattern: null,
        expiryIncluded: true,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Image",
        createdAt: "2024-11-01T15:49:30.000Z",
        updatedAt: "2024-11-01T15:49:30.000Z",
      },
      {
        id: "21e704a8-9fc2-47de-a1b5-dec66a5a38fd",
        name: "BIC",
        mandatory: true,
        imageType: "Single",
        pattern: null,
        expiryIncluded: false,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Text",
        createdAt: "2024-12-19T15:38:06.000Z",
        updatedAt: "2024-12-19T15:38:06.000Z",
      },
      {
        id: "00ac40d0-68a8-4b76-b4a5-d856130a1c7c",
        name: "IBAN",
        mandatory: true,
        imageType: "Single",
        pattern: "^[a-zA-Z0-9]{18,18}$",
        expiryIncluded: false,
        networkId: "297be3e5-53c6-480f-9b54-e1aa47efe162",
        type: "Pattern",
        createdAt: "2024-12-19T15:38:06.000Z",
        updatedAt: "2024-12-19T15:38:06.000Z",
      },
    ],
  },
};
